import { render } from "./PoorApplications.vue?vue&type=template&id=d8d9c7c0&scoped=true"
import script from "./PoorApplications.vue?vue&type=script&lang=js"
export * from "./PoorApplications.vue?vue&type=script&lang=js"

import "./PoorApplications.vue?vue&type=style&index=0&id=d8d9c7c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8d9c7c0"]])

export default __exports__